import React from 'react';
import { BrandName } from './BrandName';

export function BrandHighlight({ text }: { text: string }) {
  if (!text.includes('Broom Wagon')) return <>{text}</>;
  const parts = text.split('Broom Wagon');
  return (
    <>
      {parts.map((part, i) => (
        <React.Fragment key={i}>
          {part}
          {i < parts.length - 1 && <BrandName />}
        </React.Fragment>
      ))}
    </>
  );
}
